var React = require('react');

function Clearscore (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M7.222 21.557a3.221 3.221 0 110 6.443 3.221 3.221 0 010-6.443zM28 4v22.84H14.273a7.31 7.31 0 00.3-2.061c0-.718-.109-1.411-.301-2.068h9.598V8.13H9.288v9.6a7.32 7.32 0 00-2.066-.301c-.717 0-1.409.108-2.064.3V4H28z","id":"prefix__a"})),React.createElement("g",{"fillRule":"evenodd","key":1},React.createElement("use",{"xlinkHref":"#prefix__a"}))]);
}

Clearscore.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Clearscore;

Clearscore.default = Clearscore;
